import { EditorTab, SnippetExperience } from "../../utilities/types";
import { avatarCustomizeEntries } from "./avatar/avatarCustomizeEntries";
import { AvatarCategory } from "./avatar/types";
import { chatCustomizeEntries } from "./chat/chatCustomizeEntries";
import { ChatCategory } from "./chat/types";
import { generalCustomizeEntries } from "./general/generalCustomizeEntries";
import { GeneralCategory } from "./general/types";
import { CustomizationEntry, CustomizationTab } from "./types";
import { voiceCustomizeEntries } from "./voice/voiceCustomizeEntries";
import { VoiceCategory } from "./voice/types";

export * from "./types";

export const customizationTabs: CustomizationTab[] = [
    //previewMode is for init. if u select Voice for example, the websnippet will show the Voice snippet by default
    {
        key: EditorTab.General,
        text: 'General',
        categories: Object.values(GeneralCategory),
        entries: generalCustomizeEntries,
        previewMode: SnippetExperience.Chat,
    },
    {
        key: EditorTab.Chat,
        text: 'Chat',
        categories: Object.values(ChatCategory),
        entries: chatCustomizeEntries,
        previewMode: SnippetExperience.Chat,
    },
    {
        key: EditorTab.Voice,
        text: 'Voice',
        categories: Object.values(VoiceCategory),
        entries: voiceCustomizeEntries,
        previewMode: SnippetExperience.Voice,
    },
    {
        key: EditorTab.Avatar,
        text: 'Avatar',
        categories: Object.values(AvatarCategory),
        entries: avatarCustomizeEntries,
        previewMode: SnippetExperience.Avatar,
    },
];

export const getCustomizationTab = (key: EditorTab): CustomizationTab | undefined =>
    customizationTabs.find(tab => tab.key === key);

export const allCustomizationEntries: CustomizationEntry[] =
    ([] as CustomizationEntry[]).concat(...customizationTabs.map(tab => tab.entries));
